import React from 'react';
import { BannerTypes } from '@gin-betting/banners';
import { map, get } from 'lodash';

import useBannersCarousel from './useBannersCarousel';
import { Carousel } from 'components';
import promo from 'modules/promo';
import './bannerCarousels.scss';

const {
    components: { Banner },
} = promo;

interface Props {
    zoneLocation: BannerTypes.BannerZoneLocation;
}

const BannersCarousel: React.FC<Props> = ({ zoneLocation }) => {
    const { zoneIntervals, banners } = useBannersCarousel({
        zoneLocation,
    });

    return (
        <React.Fragment>
            {map(banners, ([zoneId, items]) => {
                const delay = get(zoneIntervals, zoneId, undefined);

                return (
                    <div styleName="container">
                        <Carousel
                            hasControls={false}
                            delay={delay}
                            direction="left"
                        >
                            {map(items, (banner, idx) => (
                                <Banner
                                    key={banner.id ?? idx}
                                    banner={banner}
                                    zoneLocation={zoneLocation}
                                />
                            ))}
                        </Carousel>
                    </div>
                );
            })}
        </React.Fragment>
    );
};

export default React.memo(BannersCarousel);
